import React from "react";
import { Instagram, Phone, MapPin } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_streamlined-events/artifacts/7p0ticvb_NP%20logo%201.png";

export const Footer = () => {
  return (
    <footer
      id="footer"
      className="md:px-[7.6923%] py-16 px-5 bg-footer-gradient grain-overlay"
      style={{ borderTop: "1px solid var(--np-border)" }}
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start gap-10">
          <div>
            <img
              src={LOGO_URL}
              alt="Network Playground"
              className="h-20 object-contain mb-4"
            />
            <p className="text-base max-w-[300px]" style={{ color: "var(--np-text-muted)" }}>
              We build what others don't see—until it's all they see.
            </p>
          </div>

          <div className="flex flex-col gap-3">
            <h4 className="text-base font-semibold mb-1" style={{ color: "var(--np-text)" }}>
              Get in touch
            </h4>
            <a
              href="tel:+916363323202"
              className="flex items-center gap-2 text-sm transition-colors"
              style={{ color: "var(--np-text-muted)" }}
            >
              <Phone size={14} /> +91 6363323202
            </a>
            <a
              href="https://instagram.com/networkplayground"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-sm transition-colors"
              style={{ color: "var(--np-text-muted)" }}
            >
              <Instagram size={14} /> @networkplayground
            </a>
            <span
              className="flex items-center gap-2 text-sm"
              style={{ color: "var(--np-text-muted)" }}
            >
              <MapPin size={14} /> Jodhpur, India
            </span>
          </div>
        </div>

        <div
          className="mt-12 pt-6 flex flex-col md:flex-row justify-between items-center gap-4"
          style={{ borderTop: "1px solid var(--np-border)" }}
        >
          <p className="text-sm" style={{ color: "var(--np-text-faint)" }}>
            &copy; {new Date().getFullYear()} Network Playground. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
